import {
  COLOR_GREEN_900,
  COLOR_NEUTRAL_700,
  COLOR_BLUE_700,
  COLOR_BLUE_900,
  COLOR_NEUTRAL_300,
  COLOR_GREEN_600,
  COLOR_BLUE_600
} from '@alltrails/denali/tokens';
import { createPinMarker } from './svgMarkerComponents';

const getFill = (isActive = false, isClosed = false, isCustomRoute = false, isSaved = false, isCompleted = false) => {
  if (isClosed) {
    return isActive ? COLOR_GREEN_600 : COLOR_NEUTRAL_300;
  }
  if (isCustomRoute) {
    return isActive ? COLOR_BLUE_900 : COLOR_BLUE_700;
  }
  if (isSaved && !isActive) {
    return COLOR_BLUE_600;
  }
  if (isCompleted && !isActive) {
    return COLOR_NEUTRAL_700;
  }
  if (isActive) {
    return COLOR_GREEN_600;
  }
  return COLOR_GREEN_900;
};

type CreateTrailPinSvgProps = {
  imageName: string;

  trailCount: number;

  isActive?: boolean;

  isClosed?: boolean;

  isCustomRoute?: boolean;
  isSaved?: boolean;
  isCompleted?: boolean;
  isCollapsed?: boolean;
};

const createTrailPinSvg = ({
  imageName,
  trailCount,
  isActive = false,
  isClosed = false,
  isCustomRoute = false,
  isSaved = false,
  isCompleted = false,
  isCollapsed = false
}: CreateTrailPinSvgProps) => {
  const innerFill = getFill(isActive, isClosed, isCustomRoute, isSaved, isCompleted);
  const closedTextFill = isClosed && !isActive ? COLOR_NEUTRAL_700 : undefined;
  return createPinMarker({
    imageName,
    innerFill,
    dashFill: closedTextFill,
    numberContent: trailCount > 1 && !isCustomRoute ? trailCount : undefined,
    renderInnerDot: !isClosed && trailCount === 1,
    renderInnerDash: isClosed && trailCount === 1,
    textFill: closedTextFill,
    renderInnerBookmark: isSaved && trailCount === 1,
    renderCheckmark: isCompleted && trailCount === 1,
    isCollapsed
  });
};

export default createTrailPinSvg;
